import { useField } from 'react-final-form'
import { composeValidators, selectRequired } from '../../utilities/validate'
import {} from './/treeCheckboxType'

export type FieldRequired = boolean | { showAsterisk?: boolean; triggedValidate?: boolean; errorMessage?: string }

function useTreeCheckbox(props: any) {
    const { name, required, validates = [] } = props
    let mergeValidate = validates
    if ((typeof required === 'boolean' && required) || (typeof required === 'object' && required.triggedValidate)) {
        mergeValidate = [
            selectRequired(typeof required === 'object' ? required.errorMessage : undefined),
            ...mergeValidate,
        ]
    }
    /* Validate */
    const field = useField<string>(name, {
        validate: composeValidators(...mergeValidate),
    })

    return { field }
}

export default useTreeCheckbox
